export type AnalyticsTone = "healthy" | "warning" | "unavailable" | "unknown";

interface AnalyticsMetadata {
  status?: string | null;
  reason?: string | null;
  model?: string | null;
  observedAt?: string | null;
}

export function analyticsTone(status: string | null | undefined): AnalyticsTone {
  const normalized = status?.trim().toLowerCase();
  if (!normalized) return "unknown";
  if (["calculated", "complete", "ready", "ok"].includes(normalized)) {
    return "healthy";
  }
  if (
    normalized.includes("degrad") ||
    normalized.includes("pending") ||
    normalized.includes("stale")
  ) {
    return "warning";
  }
  if (
    normalized.includes("unavailable") ||
    normalized.includes("unsupported") ||
    normalized.includes("invalid") ||
    normalized.includes("expired") ||
    normalized.includes("out_of_bounds") ||
    normalized.includes("not_bracketed") ||
    normalized.includes("error") ||
    normalized.includes("fail")
  ) {
    return "unavailable";
  }
  return "unknown";
}

export function analyticsReasonLabel(reason: string | null | undefined): string {
  if (!reason?.trim()) return "Analytics are not available for this observation";
  const readable = reason.trim().replaceAll("_", " ");
  return `${readable.charAt(0).toUpperCase()}${readable.slice(1)}`;
}

export function analyticsStatusLabel(status: string | null | undefined): string {
  const normalized = status?.trim().replaceAll("_", " ").toUpperCase();
  return normalized ? `ANALYTICS ${normalized}` : "ANALYTICS PENDING";
}

export function optionIntervalBasisLabel(
  nativeInterval: boolean | null | undefined,
): "NATIVE" | "DERIVED" | null {
  if (nativeInterval === null || nativeInterval === undefined) return null;
  return nativeInterval ? "NATIVE" : "DERIVED";
}

export function analyticsDisclosure({
  status,
  reason,
  model,
  observedAt,
}: AnalyticsMetadata): string {
  const parts: string[] = [];
  if (status) parts.push(analyticsStatusLabel(status));
  if (model) parts.push(`Local model: ${model.replaceAll("_", " ")}`);
  if (reason) parts.push(analyticsReasonLabel(reason));
  if (observedAt) {
    const timestamp = new Date(observedAt);
    if (!Number.isNaN(timestamp.getTime())) {
      parts.push(`Observed ${timestamp.toLocaleString()}`);
    }
  }
  return parts.join(" · ") || "Analytics metadata pending";
}
